/**
 * Live transform username/slug podczas wpisywania. Pozwala dziecku/rodzicowi
 * wpisać "Kasia" lub "Łukasz Polski" — input pokazuje "kasia" / "lukasz-polski".
 * Schema dalej waliduje (a-z 0-9 -), ale user nie widzi błędu walidacji bo
 * input juz nie pokazuje niedozwolonych znaków.
 *
 * Reguły:
 * - toLowerCase
 * - NFD + usuń diakrytyki (Ł→L, ą→a, ż→z, …)
 * - spacje / `_` / `.` → myślnik
 * - inne znaki nieobsługiwane → wywal
 * - multi-myślniki sprowadź do jednego
 * - trim myślników z brzegów
 */
export function normalizeUsername(input: string): string {
  return input
    .toLowerCase()
    // Ł/ł nie rozkładają się przez NFD (to glify, nie litery z diakrytykiem),
    // więc trzeba obsłużyć je explicit przed NFD strip.
    .replace(/ł/g, "l")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[\s_.]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}
